import React, { forwardRef, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useDemo1Layout } from '../';
import { toAbsoluteUrl } from '@/utils';
import { SidebarToggle } from './';

interface SidebarOptions {
  theme: string; // 'light' or 'dark'
}

interface LayoutOptions {
  sidebar: SidebarOptions;
}

interface Layout {
  options: LayoutOptions;
}

interface Demo1LayoutContext {
  layout: Layout;
  setSidebarCollapse: (value: boolean) => void;
}

const SidebarHeader = forwardRef<HTMLDivElement, unknown>((props, ref) => {
  const { layout } = useDemo1Layout() as unknown as Demo1LayoutContext;

  const lightLogo = () => (
    <Fragment>
      {/* Light mode logo */}
      <Link to="/" className="dark:hidden" aria-label="Saaristo Admin Logo">
        <img
          src={toAbsoluteUrl('/media/app/logo.svg')}
          alt="Saaristo Admin Logo"
          className="default-logo max-h-10 w-[130px] invert dark:invert-0 contrast:invert-0"
        />
        <img
          src={toAbsoluteUrl('/media/app/logo.svg')}
          alt="Logo"
          aria-hidden="true"
          className="max-h-8 small-logo invert dark:invert-0 contrast:invert-0"
        />
      </Link>

      {/* Dark mode logo */}
      <Link
        to="/"
        className="hidden dark:block"
        aria-label="Saaristo Admin Logo"
      >
        <img
          src={toAbsoluteUrl('/media/app/logo.svg')}
          alt="Saaristo Admin Logo"
          className="default-logo max-h-10 w-[120px] invert dark:invert-0 contrast:invert-0"
        />
        <img
          src={toAbsoluteUrl('/media/app/logo.svg')}
          alt="Logo"
          aria-hidden="true"
          className="max-h-8 small-logo invert dark:invert-0 contrast:invert-0"
        />
      </Link>
    </Fragment>
  );

  const darkLogo = () => (
    <Fragment>
      <Link to="/" aria-label="Saaristo Admin Logo">
        <img
          src={toAbsoluteUrl('/media/app/logo.svg')}
          alt="Saaristo Admin Logo"
          className="default-logo max-h-8 w-[120px] invert dark:invert-0 contrast:invert-0"
        />
        <img
          src={toAbsoluteUrl('/media/app/logo.svg')}
          alt="Saaristo Admin Logo"
          aria-hidden="true"
          className="small-logo invert dark:invert-0 contrast:invert-0"
        />
      </Link>
    </Fragment>
  );

  return (
    <div
      ref={ref}
      className="sidebar-header hidden lg:flex items-center relative justify-center px-3 lg:px-6 shrink-0"
    >
      {layout.options.sidebar.theme === 'light' ? lightLogo() : darkLogo()}
      <SidebarToggle />
    </div>
  );
});

export { SidebarHeader };
